export default __webpack_public_path__ + "static/media/2.8fe2f345.png";